import { DependencyList, useCallback, useEffect, useState } from "react";

// https://reacthustle.com/blog/speed-up-your-react-apps-by-using-debounce-with-typescript

export function useDebounce<T>(value: T, delay: number): T {
	const [debouncedValue, setDebouncedValue] = useState<T>(value);

	useEffect(() => {
		const handler = setTimeout(() => {
			setDebouncedValue(value);
		}, delay || 500);

		return () => {
			clearTimeout(handler);
		};
	}, [value, delay]);

	return debouncedValue;
}

export function useDebounceEffect(effect: any, deps: DependencyList, delay = 250) {
	const callback = useCallback(effect, deps);

	useEffect(() => {
		const timeout = setTimeout(callback, delay);
		return () => clearTimeout(timeout);
	}, [callback, delay]);
}
